/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fixed_Event_Overlap_SuccessInputs */



/**
* | output |
* | --- |
* | "Fixed event overlap for all events successfully" |
*
* @param {Fixed_Event_Overlap_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const fixed_event_overlap_success = /** @type {((inputs?: Fixed_Event_Overlap_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fixed_Event_Overlap_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chevauchement des événements corrigé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisüberschneidung wurde erfolgreich behoben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrapposizione degli eventi corretta per tutti gli eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Устранено перекрытие событий для всех событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se solucionó con éxito la superposición de eventos para todos los eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有事件的事件重叠问题均已成功解决。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのイベントの重複を修正しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी इवेंट्स के लिए इवेंट ओवरलैप को सफलतापूर्वक ठीक कर दिया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sobreposição de eventos corrigida para todos os eventos com sucesso.")
	return /** @type {LocalizedString} */ ("Fixed event overlap for all events successfully")
});